import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CompanyProvider, useCompany } from "./context/CompanyContext";
import Layout from "./components/Layout";
import AuthCallback from "./components/AuthCallback";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import TransactionsPage from "./pages/TransactionsPage";
import ImportPage from "./pages/ImportPage";
import InvoicesPage from "./pages/InvoicesPage";
import ReceivablesPage from "./pages/ReceivablesPage";
import DailyBalancePage from "./pages/DailyBalancePage";
import ReconciliationPage from "./pages/ReconciliationPage";
import RecurringPage from "./pages/RecurringPage";
import ReportsPage from "./pages/ReportsPage";
import AnnualPage from "./pages/AnnualPage";
import PartnersPage from "./pages/PartnersPage";
import WorkersPage from "./pages/WorkersPage";
import VehiclesPage from "./pages/VehiclesPage";
import CalendarPage from "./pages/CalendarPage";
import ActivityPage from "./pages/ActivityPage";
import NewsPage from "./pages/NewsPage";
import HelpPage from "./pages/HelpPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const { loaded } = useCompany();
  if (loading || (user && !loaded)) return <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] text-sm text-[#475569]">Učitavanje...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  // read hash from useLocation (reactive), not window.location.hash
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/transakcije" element={<TransactionsPage />} />
        <Route path="/uvoz" element={<ImportPage />} />
        <Route path="/racuni" element={<InvoicesPage />} />
        <Route path="/nenaplaceno" element={<ReceivablesPage />} />
        <Route path="/dnevni-saldo" element={<DailyBalancePage />} />
        <Route path="/uskladivanje" element={<ReconciliationPage />} />
        <Route path="/kalendar" element={<CalendarPage />} />
        <Route path="/fiksni-troskovi" element={<RecurringPage />} />
        <Route path="/izvjestaji" element={<ReportsPage />} />
        <Route path="/godisnji" element={<AnnualPage />} />
        <Route path="/partneri" element={<PartnersPage />} />
        <Route path="/radnici" element={<WorkersPage />} />
        <Route path="/vozila" element={<VehiclesPage />} />
        <Route path="/administracija" element={<AdminPage />} />
        <Route path="/aktivnost" element={<ActivityPage />} />
        <Route path="/novosti" element={<NewsPage />} />
        <Route path="/upute" element={<HelpPage />} />
        <Route path="/postavke" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CompanyProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </CompanyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
